module.exports = __webpack_public_path__ + "img/reporte_kl.f94410d5.png";